module.exports = __webpack_public_path__ + "static/media/technology-tie.161cc94a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/technology-tie.svg
// module id = 200
// module chunks = 6